import { create } from 'zustand';

interface OptionSelectorState {
  visible: boolean;
  targetCommitId: string | null;
  targetCreatedAt: string | null;
  setTarget: (commitId: string, createdAt: string | null) => void;
  reset: () => void;
}

const initialState = {
  visible: false,
  targetCommitId: null,
  targetCreatedAt: null,
};

export const useModalVersionSwitch = create<OptionSelectorState>(set => ({
  ...initialState,
  setTarget: (targetCommitId, targetCreatedAt) => set({
    visible: true,
    targetCommitId,
    targetCreatedAt,
  }),
  reset: () => set(initialState),
}));
